<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true}">
        <div class="close" v-on:click="close(false)"></div>
        <h4 class="modalTitle">Select Video Size</h4>
        <div class="selectorCnt">
          <a :href="detail.vid1080p" v-if="detail.vid1080p" download
            target="_blank" class="selectorItem" v-on:click="recordDownload">
            <h4>1080p<span class="hd">HD</span></h4>
          </a>
          <a :href="detail.vid720p" v-if="detail.vid720p" download
            target="_blank" class="selectorItem" v-on:click="recordDownload">
            <h4>720p</h4>
          </a>
          <a :href="detail.vid480p" v-if="detail.vid480p" download
            target="_blank" class="selectorItem" v-on:click="recordDownload">
            <h4>480p</h4>
          </a>
          <a :href="detail.vid360p" v-if="detail.vid360p" download
            target="_blank" class="selectorItem" v-on:click="recordDownload">
            <h4>360p</h4>
          </a>
        </div>
      </div>
      <Snackbar ref="snackbar"/>
    </div>
  </transition>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';

export default {
  name: 'shareDialog',
  components: { Snackbar },
  data() {
    return {
      show: false,
      next: null,
      detail: null,
      sessionId: '',
    };
  },
  methods: {
    recordDownload() {
      const alUri = `content/${this.detail.id}/download?session=${this.sessionId}`;
      this.$http.get(this.$config.uri(alUri)).then(() => {});
    },
    open(d, sessionId, next) {
      this.detail = d;
      this.sessionId = sessionId;
      this.show = true;
      this.next = next;
    },
    close(b, o) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, o);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px 20px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      box-sizing: border-box;
      width: 400px;
      max-width: 100%;
      @media (max-height: 680px) {
        padding: 30px 20px 100px;
        margin: 0; top: auto; bottom: 0;
        border-radius: 5px 5px 0 0;
      }
      .close{
        position: absolute;
        right: 6px; top: 6px;
        width: 40px; height: 40px;
        border-radius: 50%;
        background-image: url(../assets/close.png);
        background-size: 14px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .4;
        cursor: pointer;
        transition: all .2s ease;
        &:hover{
          background-color: #e9e9e9;
          opacity: .8;
        }
      }
      .modalTitle{
        padding: 20px 40px 10px;
        font-size: 28px;
        margin: -30px -40px 20px;
        background-color: #eee;
        text-align: left;
        @media (max-height: 680px) {
          background-color: #fff;
          margin: -30px 0 24px;
          font-size: 24px;
          padding: 20px 0 0;
        }
      }
      .shareDivider{
        margin: 20px 34px 10px;
        border-top: #eee 1px solid;
        @media (max-height: 680px) {
          margin: 20px 0 10px;
        }
      }
      .shareAt{
        margin: 0 34px;
        padding: 4px 0;
        padding-left: 28px;
        position: relative;
        cursor: pointer;
        @media (max-height: 680px) {
          margin: 0;
        }
        .checkbox{
          width: 18px; height: 18px;
          border: #999 2px solid;
          border-radius: 3px;
          position: absolute;
          left: 0; top: 4px;
          background-position: center;
          background-repeat: no-repeat;
          background-size: 14px auto;
          transition: all .3s ease;
          &.checked{
            background-color: #002f5f;
            border-color: #002f5f;
            background-image: url(../assets/checked.png);
          }
        }
        &:hover{
          .checkbox{
            border-color: #444;
            &.checked{
              border-color: #002f5f;
            }
          }
        }
      }
      .shareLink{
        margin: 20px 34px 0;
        background-color: #f5f5f5;
        border: #ccc 1px solid;
        border-radius: 3px;
        color: #222;
        padding: 10px 12px;
        position: relative;
        padding-right: 80px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (max-height: 680px) {
          margin: 20px 0 0;
        }
        .copy{
          position: absolute;
          right: 4px; top: 4px;
          font-weight: 600;
          color: #005ab5;
          padding: 6px 10px;
          border-radius: 3px;
          cursor: pointer;
          &:hover{
            background-color: #ddd;
          }
        }
      }
      .selectorCnt{
        .selectorItem{
          padding: 12px 20px 10px;
          padding-left: 80px;
          margin: 0 -40px;
          transition: all .2s ease;
          position: relative;
          display: block;
          &:before{
            content: "";
            position: absolute;
            left: 40px; top: 0; bottom: 6px; width: 20px;
            background-image: url(../assets/download-icon.png);
            background-size: 20px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            cursor: pointer;
            background-color: #f5f5f5;
          }
          h4{
            margin: 0;
            font-size: 17px;
            font-weight: 600;
            color: #444;
            span.hd{
              color: red;
              padding-left: 4px;
            }
          }
        }
      }
    }
  }
</style>
